module.exports = __webpack_public_path__ + "img/miscellaneous.8f88cfed.png";